import { render, staticRenderFns } from "./VirReport.vue?vue&type=template&id=4ae82df0"
import script from "./VirReport.vue?vue&type=script&lang=js"
export * from "./VirReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports